import advertisers from "./advertisers";
import advertising from "./advertising";
import connections from "./connections";
import devices from "./devices";
import establishments from "./establishments";
import integrations from "./integrations";
import interactions from "./interactions";
import leads from "./leads";
import local from "./local";
import partners from "./partners";
import paginated from "./paginated-loader";
import promocionalcode from "./promocionalcode";
import statistics from "./statistics";
import users from "./users";

export default {
    install(Vue) {
        Vue.prototype.$loader = Vue.loader = this;
    },

    paginated,

    advertisers,
    partners,
    advertising,
    establishments,
    interactions,
    users,
    leads,
    statistics,
    devices,
    integrations,
    promocionalcode,
    connections,
    local,
};
